import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";
import customAxios from "../../customAxios";
import { FIND_SCHOOL, GET_ALL_SCHOOL } from "../../routes";

const findSchoolPost = async (props: IFindUserInformation) => {
  var thisUrl = "";
  if (props?.page && props?.limit)
    thisUrl = `?page=${props.page}&limit=${props.limit}`;

  let body: any = {
    page: props.page,
    limit: props.limit,
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: String(props.search.base),
        searchValue: utils.convertNumbers2English(props.search.value),
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { province, city, isApproved, gender } = props.filters;
    body = {
      ...body,
      province: province?._id,
      city: city?._id ? city?._id : city,
      approved: isApproved,
      gender: gender?.value,
    };
  }
  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(FIND_SCHOOL + thisUrl, body)).data;
  } catch (error: any) {
    console.log({ GET_ALL_SCHOOL: error });
  }
};

export default findSchoolPost;
